import { Box, Button, Stack } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { GLItemsDTO } from "../../../DTO/GLItemsDTO";
import LogChatCreateMsg from "./LogChatCreateMsg";
import LogChatMsg from "./LogChatMsg";
import { InfinitScroll } from "../../../services/InfinitScroll";
import { GLItemKind, GLItemStatus } from "../../../DTO/GLItemDTO";
import { AccessAlarm, ZoomIn, ZoomOut, Person } from "@mui/icons-material";

import './LogChat.scss'

enum Status {
  loading,
  loadMore,
  idle,
}

export default function LogChat({
  id,
  personId,
  customerId,
  disableNewMsg,
  needle,
  kind,
  statusKind,
  onClickDetail,
  initDisplaySize = 'minItems',
  markedId = -1,
  userId = -1,
  pastduedate = false,
  onAlarmButton,
  onPersonButton,
}: {
  id?: number,
  personId?: number,
  customerId?: number,
  disableNewMsg?: boolean,
  needle?: string,
  kind?: GLItemKind,
  statusKind?: GLItemStatus,
  onClickDetail?: (id: number) => void,
  initDisplaySize?: 'minItems' | 'normalItems',
  markedId?: number,
  userId?: number,
  pastduedate?: boolean,
  onAlarmButton?: () => void,
  onPersonButton?: () => void,
}) {
  const [status, setStatus] = useState(Status.loading)
  const [minMax, setMinMax] = useState<'minItems' | 'normalItems'>(initDisplaySize)
  const [localMarkedId, setLocalMarkedId] = useState(markedId)
  const [glitems] = useState(new GLItemsDTO({
    id: id && id > -1 ? id : undefined,
    page: 1,
    limit: 20,
    personId,
    customerId,
    needle,
    kind,
    status: statusKind,
    userId,
    pastduedate,
  }))

  useEffect(() => {
    setLocalMarkedId(markedId)
  }, [markedId])
  useEffect(() => {
    setStatus(Status.loading)
    glitems.patchRequest({
      personId,
      customerId,
      kind,
      status: statusKind,
      userId: userId,
      pastduedate: pastduedate,
    })
    glitems.getFresh().then(() => setStatus(Status.idle))
  }, [personId, customerId, kind, statusKind, userId, pastduedate])

  useEffect(() => {
    setStatus(Status.loading)
    glitems.setNeedle(needle || '').then(() => setStatus(Status.idle))
  }, [needle])

  async function refresh() {
    setStatus(Status.loading)
    await glitems.getFresh()
    setStatus(Status.idle)
  }

  const [infinitScroll] = useState(new InfinitScroll({
    ref: useRef(null),
    cb: async () => {
      console.log('infinitscroll cb')
      if (!glitems.allowInfinitScroll) { return }
      setStatus(Status.loadMore)
      await glitems.getNextPage()
      setStatus(Status.idle)
    },
    saveScrollPositionCb: (scrollPosition: number) => {
      console.log('current scroll position')
    },
    page: 1,
  }))


  return <Box>
    <Stack
      spacing={1}
      ref={infinitScroll.getRef()}
      className={`LogChat scrollContent`}
      sx={{
        maxHeight: '90vh'
      }}
    >
      {
        id && id > -1 && <Box>
          <h3>{glitems.getHeadline1()}</h3>
          <h4>{glitems.getHeadline2()}</h4>
        </Box>
      }
      <Stack
        direction={'row'}
        spacing={1}
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
          }}
        ></Box>
        {
          onAlarmButton && <Button
            onClick={onAlarmButton}
            variant={pastduedate ? 'contained' : 'text'}
          >
            <AccessAlarm />
          </Button>
        }
        {
          onPersonButton && <Button
            onClick={onPersonButton}
            variant={userId > -1 ? 'contained' : 'text'}
          >
            <Person />
          </Button>
        }
        {
          minMax === 'minItems' ? <Button
            onClick={() => setMinMax('normalItems')}
          >
            <ZoomIn /> Mehr anzeigen
          </Button> : <Button
            onClick={() => setMinMax('minItems')}
          >
            <ZoomOut /> Weniger anzeigen
          </Button>
        }
      </Stack>
      {
        !disableNewMsg &&
        <LogChatCreateMsg
          saveCB={refresh}
          personId={personId}
          id={id}
        />
      }
      {status === Status.loading && <Box>Lade...</Box>}
      {status !== Status.loading && glitems.items.length === 0 && <Box>Keine Einträge</Box>}

      <Stack
        spacing={4}
        className={minMax}
      >
        {status !== Status.loading && glitems.get().map(item =>
          <LogChatMsg
            key={item.id}
            saveCB={refresh}
            item={item}
            onClickDetail={onClickDetail}
            marked={item.id === localMarkedId}
          />)}
      </Stack>
    </Stack>
  </Box>
}
